<template>
  <v-data-table
    :headers="header"
    :items="itens"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    item-key="id"
    class="table-wkf-resposivo"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Itens de Análise</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          outlined
          single-line
          hide-details
          clearable
          v-lazy-input:debounce="400"
          class="pr-4 pl-4 search"
        ></v-text-field>
        <v-dialog
          persistent
          v-model="dialog"
          max-width="600px"
          content-class="wkf-item"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Novo</v-btn>
          </template>
          <v-card style="border: 1px solid #fff">
            <v-toolbar dark flat color="#042333" height="50px">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text style="min-height: 75vh" class="pb-0" align-center>
              <v-text-field
                outlined
                v-model="form.descricao"
                label="Descrição*"
                class="mt-6"
                autofocus
                :error-messages="errorDescricao"
                @input="$v.form.descricao.$touch()"
                @blur="$v.form.descricao.$touch()"
              ></v-text-field>

              <v-select
                v-model="form.tipo"
                :items="selects.tipo"
                label="Tipo"
                outlined
                :error-messages="errorTipo"
                @input="$v.form.tipo.$touch()"
                @blur="$v.form.tipo.$touch()"
              ></v-select>
              <v-select
                v-model="form.grupo"
                :items="selects.grupo"
                label="Grupo"
                outlined
                :error-messages="errorGrupo"
                @input="$v.form.grupo.$touch()"
                @blur="$v.form.grupo.$touch()"
              ></v-select>
              <v-select
                v-model="form.regra"
                :items="selects.regra"
                label="Regra"
                outlined
                :error-messages="errorTipo"
                @input="$v.form.regra.$touch()"
                @blur="$v.form.regra.$touch()"
              ></v-select>
              <v-autocomplete
                v-model="form.tabela_referencia"
                :items="selects.tabela"
                label="Tabela"
                outlined
                :error-messages="errorTipo"
                @input="$v.form.tabela_referencia.$touch()"
                @blur="$v.form.tabela_referencia.$touch()"
              ></v-autocomplete>
              <v-select
                v-model="form.coluna_referencia"
                :items="selects.coluna"
                label="Coluna"
                outlined
                :error-messages="errorColuna"
                @input="$v.form.coluna_referencia.$touch()"
                @blur="$v.form.coluna_referencia.$touch()"
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" @click="close()"> Cancelar </v-btn>
              <v-btn color="#042333" dark @click="salvar">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn icon title="Editar Item" @click="editar(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon title="Remover Item" @click="excluir(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.tipo="{ item }">
      <div v-if="item.tipo == 1">Campo Descritivo (Sim, Não)</div>
      <div v-if="item.tipo == 2">Campo Quantitativo (Valores)</div>
    </template>
    <template v-slot:item.grupo="{ item }">
      <div v-if="item.grupo == 1">Autonomias</div>
      <div v-if="item.grupo == 2">Parâmentros</div>
      <div v-if="item.grupo == 3">Visualizações</div>
    </template>
    <template v-slot:item.regra="{ item }">
      <div v-if="item.regra == 1">
        Ativa(A regra será aplicada no momento da ação)
      </div>
      <div v-if="item.regra == 2">
        Reativa(A regra será enviado para workflow de aprovação)
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      header: [
        { text: "#", value: "id", width: "77px", align: "center" },
        { text: "Descrição", value: "descricao" },
        { text: "Grupo", value: "grupo", width: "120px" },
        { text: "Tipo", value: "tipo", width: "210px" },
        { text: "Regra", value: "regra", width: "230px" },
        { text: "Tabela", value: "tabela_referencia", width: "230px" },
        { text: "Coluna", value: "coluna_referencia", width: "230px" },
        { value: "action", sortable: false, width: "100px", align: "center" },
      ],
      search: "",
      dialog: false,
      title: "Novo Item",
      form: {
        id: "",
        descricao: "",
        tabela_referencia: "",
        coluna_referencia: "",
        tipo: [],
        grupo: [],
        regra: [],
      },
    };
  },
  validations: {
    form: {
      descricao: { required },
      tabela_referencia: { required },
      coluna_referencia: { required },
      tipo: { required },
      grupo: { required },
      regra: { required },
    },
  },
  computed: {
    ...mapGetters("wkfItem", ["itens", "selects"]),
    errorDescricao() {
      const errors = [];
      if (!this.$v.form.descricao.$dirty) return errors;
      !this.$v.form.descricao.required &&
        errors.push("A descrição é obrigatória.");
      return errors;
    },
    errorTabelaReferencia() {
      const errors = [];
      if (!this.$v.form.tabela_referencia.$dirty) return errors;
      !this.$v.form.tabela_referencia.required &&
        errors.push("A tabela de referência é obrigatória.");
      return errors;
    },
    errorTipo() {
      const errors = [];
      if (!this.$v.form.tipo.$dirty) return errors;
      !this.$v.form.tipo.required && errors.push("O tipo é obrigatório.");
      return errors;
    },
    errorGrupo() {
      const errors = [];
      if (!this.$v.form.grupo.$dirty) return errors;
      !this.$v.form.grupo.required && errors.push("O grupo é obrigatório.");
      return errors;
    },
    errorColuna() {
      const errors = [];
      if (!this.$v.form.coluna_referencia.$dirty) return errors;
      !this.$v.form.coluna_referencia.required &&
        errors.push("A coluna é obrigatória.");
      return errors;
    },
  },
  created() {
    this.$store.dispatch("wkfItem/Itens");
    this.$store.dispatch("wkfItem/Tabela");
  },
  methods: {
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        this.$store.dispatch("wkfItem/Delete", {
          id: item.id,
        });
      }
    },
    editar(prop) {
      this.dialog = true;
      this.form.id = prop.id;
      this.form.descricao = prop.descricao;
      this.form.tipo = prop.tipo;
      this.form.grupo = prop.grupo;
      this.form.regra = prop.regra;
      this.form.tabela_referencia = prop.tabela_referencia;
      this.form.coluna_referencia = prop.coluna_referencia;
      this.title = "Editar Item";
      this.$v.$reset();
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (!this.form.id) {
          this.$store
            .dispatch("wkfItem/Store", this.form)
            .then(() => {
              this.close();
            })
            .catch((e) => {
              if (e.response.data.errors) {
                this.$v.$reset();
                this.$v.$touch();
              } else {
                // this.Helpers.logout();
              }
            });
        } else {
          this.$store.dispatch("wkfItem/Update", this.form).then(() => {
            this.close();
          });
        }
      }
    },
    close() {
      this.title = "Novo Item";
      this.form = {
        id: "",
        descricao: "",
        tabela_referencia: [],
        tipo: [],
        grupo: [],
        regra: [],
      };
      this.dialog = false;
      this.$v.$reset();
    },
  },
  watch: {
    "form.tabela_referencia"() {
      this.$store.dispatch("wkfItem/Coluna", {
        tabela: this.form.tabela_referencia,
      });
    },
  },
};
</script>
<style >
.wkf-item.v-dialog {
  margin: 0;
  max-height: 95%;
}
</style>
